import extraLazy from 'shared/extraLazy';
export default extraLazy(function () {
    return import(/* webpackChunkName: "replay" */ 'shared/symbols/Replay');
});
